var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserFeaturesState } from "@/app/store/modules/user-features.state";
import { MeClient } from "@/app/api/battery-portal-api";
const meClient = new MeClient(window.apiUrl);
export const state = new UserFeaturesState();
/**
 * Which group-controlled features (User Groups, Cloud only) the signed-in user can use. Loaded on
 * page load; the server still checks every request, so a stale list can only show a button that
 * then gets refused.
 */
const getters = {
    canUseFeature: (state) => (featureName) => state.canUse(featureName)
};
export const mutations = {
    setFeatures(state, features) {
        state.features = features !== null && features !== void 0 ? features : [];
    }
};
export const actions = {
    loadUserFeatures(_a) {
        return __awaiter(this, arguments, void 0, function* ({ commit }) {
            try {
                commit("setFeatures", yield meClient.features());
            }
            catch (error) {
                console.error("Failed to load user features:", error);
                commit("setFeatures", []);
            }
        });
    }
};
const namespaced = true;
export const userFeaturesModule = {
    namespaced,
    state,
    actions,
    mutations,
    getters
};
